import React from 'react'
import {get} from 'lodash'
import popup from '~/views/Popup/popup'
import connect from '~/tools/connect'
import userStore from '~/redux/user/store'
import { fetchModels } from '~/redux/models/helpers';
import { getLocalizedVal } from '~/tools/localization/helpers';
import Overlay from '~/components/Overlay';

class VideoWall extends React.Component {
  constructor(props) {
    super(props)

    this.pushButtonEvent = this.pushButtonEvent.bind(this)
  }

  async componentDidMount() {
    if (!window.dataLayer)
      return

    window.dataLayer.push({
      'event': 'soft_wall_shown',
      'video_title': this.props.videoGist.title,
      'video_id': this.props.videoGist.id
    })

    this.setState({ model: await fetchModels() })
  }

  pushButtonEvent(source) {
    if (!window.dataLayer)
      return

    window.dataLayer.push({
      'event': 'subscribe_cta_click',
      'source': source
    })
  }

  subscriptionWall = () => {
    const background = {
      background: `url(${this.props.videoGist.videoImageUrl}) no-repeat`
    }

    if (window.SERVER_SIDE_RENDERING) {
      return <div className="subscription-prompt" style={ background }></div>
    }
    
    return (
      <div className="subscription-prompt" style={ background }>
        <div className="overlay">
          <p>
            { getLocalizedVal(window.settings,'genericMessages','encourageUserToLoginLabel') }
          </p>
          <div className="button-container">
            { window.sessionStorage.getItem('openUpdatecard')
              ? <a href="/user/account" className="cta button"> Activate Now </a>
              : <a
                  href="/viewplans"
                  className="cta button"
                  onClick={ () => this.pushButtonEvent('video_wall') }
                >
                  { getLocalizedVal(window.settings,'genericMessages', 'startFreetrialButton') }
                </a>
            }

            { !this.state.user && (
              <button className="cta login-btn" onClick={ evt => popup.login(this.props.content.pricing.type) }>
                 { getLocalizedVal(window.settings,'navigation.settings','primaryCta.loginCtaText') }
              </button>
            ) }
          </div>
        </div>
      </div>
    )
  }

  purchaseWall = () => {
    const { content: video } = this.props
    const currentSeason = video.showData.seasons[video.currentSeason]
    const ids = { series: video.seriesId, season: video.seasonId }
    const contentType = get(video, 'contentType') || get(video, 'gist.contentType')

    if (contentType && contentType === 'VIDEO') {
      const videoIds = {
        ...ids,
        content: video.gist.id,
        video: video.gist.id
      }
      const items = Overlay.formatPricing(video.pricing, videoIds, video.gist.title) 
      const content = {
        gist: {
          ...currentSeason,
          contentType: 'EPISODE',
          title: video.gist.title
        }
      }
      popup.purchase(items[0], content, () => video.playEpisode())
      return null
    }
  }

  loginWall = () => {
    const background = {
      background: `url(${this.props.videoGist.videoImageUrl}) no-repeat`
    }
    const loginText = getLocalizedVal(window.settings,'navigation.settings','primaryCta.loginCtaText');

    if (window.SERVER_SIDE_RENDERING) {
      return <div className="subscription-prompt" style={ background }></div>
    }
    
    return (
      <div className="subscription-prompt" style={ background }>
        <div className="overlay">
          <p>
            {getLocalizedVal(window.settings,'genericMessages', 'entitlementLoginErrorMessage') }
          </p>
          <div className="button-container">
              <button className="cta login-btn" onClick={ evt => popup.login(this.props.content.pricing.type) }>
              { (loginText !== undefined) ? loginText: 'Login' }
              </button>
          </div>
        </div>
      </div>
    )
  }

  render() {
    const model = this.state.model && (this.state.model).toLowerCase();
    if (model === 'tvod' && this.props.isEpisode) {
      return this.purchaseWall()
    } else if(!this.state.user && (model === 'avod' || model === 'free' || (window.settings.forceLogin && this.props.videoGist.free))) {
      return this.loginWall()
    } else {
      return this.subscriptionWall()
    }
  }
}

connect(VideoWall, state => ({ user: state.user }), userStore)
export default VideoWall;
